import React, { useState, useMemo } from "react";

/**
 * Reusable searchable country select with emoji.
 */
const CountrySearchSelect = ({ countries = [], value, onChange, placeholder = "Search and select country", label = "Country", className = "" }) => {
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);

  const filtered = useMemo(() => {
    if (!search.trim()) return countries;
    const q = search.trim().toLowerCase();
    return countries.filter((c) => c.name.toLowerCase().includes(q));
  }, [countries, search]);

  const displayValue = open ? search : (value ? `${value.emoji || ""} ${value.name}`.trim() : "");

  return (
    <div className={`relative ${className}`}>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
      )}
      <div className="relative">
        <input
          type="text"
          value={displayValue}
          onChange={(e) => {
            setSearch(e.target.value);
            setOpen(true);
            if (!e.target.value) onChange(null);
          }}
          onFocus={() => {
            setOpen(true);
            setSearch(value ? value.name : "");
          }}
          onBlur={() => setTimeout(() => setOpen(false), 200)}
          placeholder={placeholder}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm pr-8"
        />
        {value && !open && (
          <button
            type="button"
            onClick={() => { onChange(null); setSearch(""); }}
            className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
            aria-label="Clear"
          >
            ×
          </button>
        )}
        {open && (
          <ul className="absolute z-10 mt-1 w-full max-h-60 overflow-auto rounded-lg border border-gray-200 bg-white shadow-lg py-1 text-sm">
            {filtered.length === 0 ? (
              <li className="px-3 py-2 text-gray-500">No country found</li>
            ) : (
              filtered.map((c) => (
                <li
                  key={c.code}
                  onMouseDown={(e) => {
                    e.preventDefault();
                    onChange(c);
                    setSearch("");
                    setOpen(false);
                  }}
                  className={`px-3 py-2 cursor-pointer hover:bg-red-50 flex items-center gap-2 ${value?.code === c.code ? "bg-red-50 text-red-700" : "text-gray-900"}`}
                >
                  <span className="text-base">{c.emoji || ""}</span>
                  <span>{c.name}</span>
                </li>
              ))
            )}
          </ul>
        )}
      </div>
    </div>
  );
};

export default CountrySearchSelect;
